import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { atoms, DropdownMenu, HStack, IconButton } from '@rtkwlf/fenrir-react';
import { faQuestionCircle } from '@rtkwlf/pro-solid-svg-icons/faQuestionCircle';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useLegacyCapabilities } from '@apis/rendall/queries/use-capabilities';
import {
  ALLOW_LIST_REQUIREMENTS_ROUTE,
  CONTACT_CONCIERGE_ROUTE,
  RESOURCE_CENTER_DOWNLOADS_ROUTE,
} from 'ae-constants/routes.constants';

const ARCTIC_CIRCLE_CUSTOMER_COMMUNITY_URL =
  'https://community.arcticwolf.com/private/login';

export const HelpMenu: React.FC = () => {
  const { t } = useTranslation('appBar');
  const { data: legacyCapabilities } = useLegacyCapabilities();

  const showCustomerCommunity = legacyCapabilities?.canAccessCustomerCommunity;

  return (
    <HStack xAlign="center">
      <DropdownMenu.Root>
        <DropdownMenu.Trigger asChild fontSize="large">
          <IconButton aria-label={t('helpMenu.tooltip')}>
            <FontAwesomeIcon icon={faQuestionCircle} size="xs" />
          </IconButton>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content align="end" width="16rem">
          <DropdownMenu.Header>
            <DropdownMenu.HeaderTitle maxWidth="12rem" truncate>
              {t('helpMenu.resourceCentreHeader')}
            </DropdownMenu.HeaderTitle>
            <DropdownMenu.HeaderDescription maxWidth="12rem" truncate>
              {t('helpMenu.helpEmail')}
            </DropdownMenu.HeaderDescription>
          </DropdownMenu.Header>
          <DropdownMenu.Label>
            {t('helpMenu.resourceCentre')}
          </DropdownMenu.Label>
          <DropdownMenu.Group>
            <DropdownMenu.Item asChild>
              <Link
                to={RESOURCE_CENTER_DOWNLOADS_ROUTE}
                className={atoms({
                  textColor: 'body',
                  textDecoration: 'none',
                  width: 'full',
                })}
              >
                {t('helpMenu.downloads')}
              </Link>
            </DropdownMenu.Item>

            {showCustomerCommunity && (
              <DropdownMenu.ExternalLinkItem
                href={ARCTIC_CIRCLE_CUSTOMER_COMMUNITY_URL}
                target="_blank"
              >
                <DropdownMenu.ExternalLinkItemText>
                  {t('helpMenu.arcticCircleCustomerCommunity')}
                </DropdownMenu.ExternalLinkItemText>
              </DropdownMenu.ExternalLinkItem>
            )}

            <DropdownMenu.Item asChild>
              <Link
                to={ALLOW_LIST_REQUIREMENTS_ROUTE}
                className={atoms({
                  textColor: 'body',
                  textDecoration: 'none',
                  width: 'full',
                })}
              >
                {t('helpMenu.allowListRequirements')}
              </Link>
            </DropdownMenu.Item>

            <DropdownMenu.ExternalLinkItem
              href={t('helpMenu.documentationUrl')}
              target="_blank"
            >
              <DropdownMenu.ExternalLinkItemText>
                {t('helpMenu.documentation')}
              </DropdownMenu.ExternalLinkItemText>
            </DropdownMenu.ExternalLinkItem>

            <DropdownMenu.ExternalLinkItem
              href={t('helpMenu.userPortalGuideUrl')}
              target="_blank"
            >
              <DropdownMenu.ExternalLinkItemText>
                {t('helpMenu.portalUserGuide')}
              </DropdownMenu.ExternalLinkItemText>
            </DropdownMenu.ExternalLinkItem>

            <DropdownMenu.Separator />
            <DropdownMenu.Item asChild>
              <Link
                to={CONTACT_CONCIERGE_ROUTE}
                className={atoms({
                  textColor: 'body',
                  textDecoration: 'none',
                  width: 'full',
                })}
              >
                {t('helpMenu.contactArcticWolf')}
              </Link>
            </DropdownMenu.Item>
          </DropdownMenu.Group>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </HStack>
  );
};
